<template>
    <div class="bg">
        <v-container>
          <div class=" nav">
            <v-icon style="position: absolute; left: 20px;color:#fff" @click="previous()"
              >mdi-arrow-left</v-icon
            >
            <v-spacer></v-spacer>
            <h2 style="margin-bottom: 0;color:#fff">Payment</h2>
            <v-spacer></v-spacer>
          </div>

           <!-- content -->
          <div :style="`height:${height}px;min-height: 70vh;border-radius: 20px;background:#fff;overflow: scroll;`">
            <v-container>
                <!-- <div style="overflow: scroll;"> -->
                    <div style="text-align:center;padding:30px 0;">
                            <h2 style="color: #8E8EA9;
                                font-family: Mulish;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 28px;">Payment</h2>
                        <p style="color: #8E8EA9;
                                text-align: center;
                                font-family: Mulish;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 28px; /* 175% */">Choose a payment method</p>
                    </div>
                    <v-radio-group v-model="pay" v-if="status_next !== true">
                    <div v-for="n in data" :key="n" style="border-radius: 16px;background: #FFF;box-shadow: 0px 4px 20px -2px rgba(50, 50, 71, 0.04), 0px 0px 1px 0px rgba(12, 26, 75, 0.03);height:80px;padding-bottom:100px">
                    <div class="radio-e" style="border-radius: 16px;">
                        <p style="padding-left:20px;margin:0;color: #212134;
                            font-family: Mulish;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 22px; /* 137.5% */">{{n.text}}</p>
                        <v-spacer></v-spacer>
                        <v-radio :value="n.value"></v-radio>
                    </div>
                    </div>
                    </v-radio-group>
                    <v-radio-group v-model="pay" v-if="status_next !== false && pay === 'promp'">
                    <div style="border-radius: 16px;background: #FFF;box-shadow: 0px 4px 20px -2px rgba(50, 50, 71, 0.04), 0px 0px 1px 0px rgba(12, 26, 75, 0.03);height:80px;padding-bottom:100px">
                    <div class="radio-e" style="border-radius: 16px;">
                        <p style="padding-left:20px;margin:0;color: #212134;
                            font-family: Mulish;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 22px; /* 137.5% */">{{n.text}}</p>
                        <v-spacer></v-spacer>
                        <v-radio value="n.value"></v-radio>
                    </div>
                    </div>
                    </v-radio-group>

                <div style="display:flex;justify-content:center;">
                    <v-btn block dark color="#25388D" class="btn-ok" @click="next">next</v-btn>
                </div>
            </v-container>
          </div>
          <!-- content -->
          <div class="foot">POWER BY  BETASK CONSULTING</div>
        </v-container>

    </div>
</template>

<script>
// import axios from 'axios' // api
export default {
  name: 'LoyaltySystemConvertRate',

  data () {
    return {
      height: '',
      ProductExchangeRate: [],
      session: this.$session.getAll(),
      pay: '',
      status_next: '',
      data: [
        {text: 'Pay via QR PromptPay', value: 'promp'},
        {text: 'Pay via credit card', value: 'credit'}
      ]

    }
  },

  mounted () {
    this.checkDeviceHeight()
  },

  methods: {
    checkDeviceHeight () {
      // Get the viewport height
      const viewportHeight = window.innerHeight
      this.height = viewportHeight - 162
    },
    aa () {
      alert('aa')
    },
    next () {
      this.status_next = true
      console.log(this.status_next)
    }

  }
}
</script>

<style scoped>
    .bg {
        background: #25388D;
        height: 100vh;
        width: 100%;
    }
    .nav {
  display: flex;
  align-items: center;
  height: 100px;
}
    .radio-e {
  display: flex;
  align-items: center;
  height: 80px;
  border-radius: 16px;
  /* background: red; */
}
.foot {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
p {
    color: #000;
}
.container {
    padding:12px 15px 0 15px;
}
.btn-ok{
    border-radius: 20px;
    height: 56px !important;
    position: absolute;
    bottom: 8%;
}
.v-btn--block {
    min-width: 85% !important;
}
.image {
    border-radius: 20px;
    background: var(--neutral-grey-5, #EEF3FC);
    width: 100%;
    height: 233px;
    flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/payment.vue